<script>
export default {
    name: "FilterIcon"
}
</script>
<template>
    <svg role="img" aria-label="Filter"  width="18" height="19" viewBox="0 0 18 19" fill="none" xmlns="http://www.w3.org/2000/svg">
        <path d="M4.21875 0.25V3.0625H6.1875V8.6875H4.21875V18.25H2.53125V8.6875H0.5625V3.0625H2.53125V0.25H4.21875ZM4.5 4.75H2.25V7H4.5V4.75ZM10.125 11.5H7.875V13.75H10.125V11.5ZM8.15625 9.8125V0.25H9.84375V9.8125H11.8125V4.1875H13.7812V0.25H15.4688V4.1875H17.4375V9.8125H15.4688V18.25H13.7812V9.8125H11.8125V15.4375H9.84375V18.25H8.15625V15.4375H6.1875V9.8125H8.15625ZM13.5 5.875V8.125H15.75V5.875H13.5Z" fill="#48707A"/>
    </svg>
</template>
